<template>
  <span v-if="onlyDot" v-b-tooltip.hover :title="text" class="dot ml-2" :style="{ backgroundColor: dotColor }"></span>
  <span v-else class="status">
    <span class="dot" :style="{ backgroundColor: dotColor }"></span>
    <span>{{ text }}</span>
  </span>
</template>

<script>
import { resolveStatuses, statusOf } from "@/modules/task/task-settings";

/** TKP-119: renk ve ad organizasyonun durum kaydından; kayıt yüklenmediyse sistem varsayılanları (eski sabitlerle birebir). */
export default {
  props: ["status", "onlyDot"],
  computed: {
    record() {
      const language = this.$store.getters["user/account"]?.language ?? "tr";
      return statusOf(resolveStatuses(this.$store.getters["taskSettings/statuses"], language, (k) => this.$t(k)), this.status);
    },
    dotColor() {
      return this.record.color;
    },
    text() {
      return this.record.label;
    },
  },
};
</script>
<style scoped>
.status {
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 20px;
  background-color: rgb(233 233 233);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}
</style>
